module.exports = __webpack_public_path__ + "static/media/Maintainance2.9844f3de.svg";